import { IntlShape, useIntl } from 'react-intl';

export let GlobalIntl: IntlShape;

export function GlobalIntlProvider(): null {
  GlobalIntl = useIntl();

  return null;
}
